import GocaraLJ from './GocaraLJ.js';
import Gocara80 from './Gocara80.js';
import Gocara60 from './Gocara60.js';

export {
  GocaraLJ,
  Gocara80,
  Gocara60
};
